export const GET_REGISTRY = 'GET_CUSTOMER_REGISTRY';
export const SUBMIT_REGISTRY = 'SUBMIT_CUSTOMER_REGISTRY';
export const SET_REGISTRY = 'SET_CUSTOMER_REGISTRY';
export const UPDATE_REGISTRY = 'UPDATE_CUSTOMER_REGISTRY';
